export type StoredAuth = {
  accessToken: string
  refreshToken: string
  role?: string
}

const KEY = 'nudge.auth'

export function saveAuth(auth: StoredAuth) {
  localStorage.setItem(KEY, JSON.stringify(auth))
}

export function loadAuth(): StoredAuth | null {
  const raw = localStorage.getItem(KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw) as StoredAuth
  } catch {
    return null
  }
}

export function clearAuth() {
  localStorage.removeItem(KEY)
  localStorage.removeItem('nudge.activePage')
  // Avoid a circular import — touch the same key directly.
  localStorage.removeItem('nudge.profile.cache')
}

export function updateAccessToken(newToken: string): void {
  const auth = loadAuth()
  if (auth) {
    saveAuth({ ...auth, accessToken: newToken })
  }
}

